'use strict';

var smallBreakpoint = 320;
var mediumBreakpoint = 480;
var largeBreakpoint = 768;
var desktopBreakpoint = 1024;
var maxBreakpoint = 1280;

var selectDropDownEnhance = function (
	shouldHideSelected,
	selectedQuantity,
	isATCUpdate,
	$activeAccordion,
	thisRef
) {
	let $this = $activeAccordion ? $activeAccordion.find(thisRef) : $(thisRef);
	if (isATCUpdate) {
		$this =
			isATCUpdate.find('select').length > 1
				? $(isATCUpdate.find('select').get(0))
				: $(isATCUpdate.find('select'));
	}

	const selectOptions = $this.children('option').length;
	let currentOption;
	var isSort = $this.prop('name') === 'sort-order-custom';
	if (isSort) {
		let url = window.location.href;
		let queryString = utils.getQueryString(url);
		let queryStringParams = utils.getQueryStringParams(queryString);
		let param = queryStringParams.srule;
		if($this && $this.length > 0 && $this[0].selectedIndex){
			currentOption = $this[0].selectedIndex;
		}
		else if (!param) {
			currentOption = 0;
		} else {
			let element = $('option[data-id=' + param + ']');
			let index = $this.children('option').index(element);
			currentOption = index;
		}
	} else {
		currentOption = 0;
	}

	$this.addClass('d-none');

	$this.after('<div class="custom-dropdown"></div>');

	const $customDropdown = $this.next('div.custom-dropdown');

	const $customDropdownSelected = $('<div />', {
		class: 'custom-dropdown__selected',
		id: 'customDropdownSelected',
	}).appendTo($customDropdown);

	const $customDropdownSelectedText = $('<span />', {
		class: 'custom-dropdown__selected--text',
	}).appendTo($customDropdownSelected);

	const $optionsContainer = $('<div />', {
		class: 'custom-dropdown__optionsWrapper',
	}).insertBefore($customDropdownSelected);

	const $customDropdownOptions = $('<ul />', {
		class: 'custom-dropdown__options',
	}).appendTo($optionsContainer);

	for (let i = 0; i < selectOptions; i++) {
		$('<li />', {
			class: 'custom-dropdown__options--item',
			text: $this.children('option').eq(i).text(),
			'data-value': $this.children('option').eq(i).val(),
			'data-browser-url': $this.children('option').eq(i).data('browser-url'),
			'data-sort-option': $this.children('option').eq(i).attr('data-sort-option'),
		}).appendTo($customDropdownOptions);
	}

	const $options = $customDropdownOptions.children('li');

	if (selectedQuantity) {
		$customDropdownSelectedText.text(selectedQuantity);
	} else {
		if($this.children('option').eq(0).text().trim() === ''){
			$customDropdownSelectedText.text($this.children('option').eq(1).text());
		}else{
			$customDropdownSelectedText.text($this.children('option').eq(currentOption).text());
		}

	}

	if (shouldHideSelected) {
		if (selectedQuantity) {
			$options.eq(selectedQuantity - 1).hide();
		} else {
			$options.eq(currentOption).hide();
		}
	}

	$customDropdownSelected.click(function () {
		$optionsContainer.toggleClass('custom-dropdown-active');
		$customDropdownSelected.toggleClass('active-dropdown');
	});

	// $('body').off('click');

	$options.each(function (index) {
		$(this).click(function () {
			if (shouldHideSelected) {
				$options.eq(currentOption).show();
				$(this).hide();
				currentOption = index;
			}

			const selectedText = $(this).text();
			$customDropdownSelectedText.text(selectedText);
			$optionsContainer.removeClass('custom-dropdown-active');

			const selectedValue = $(this).attr('data-value');
			var browserUrl = $(this).data('browser-url');
			var isFromCYO = $('#isFromCYO').data('isfromcyo');
			const sortOption = $(this).attr('data-sort-option');
			$this.val(selectedValue);
			$.spinner().start();
			$.ajax({
				url: selectedValue,
				data: { selectedUrl: selectedValue },
				method: 'GET',
				success: function (response) {
					let $accordionActive = $('.accordion-collapse.show');
					if ($accordionActive.length) {
						$accordionActive.find('.product-grid').empty().html(response);
					} else {
						$('.product-grid').not('.cartRecommendationCarousel').empty().html(response);
					}
					if(isSort && !isFromCYO){
						window.history.pushState({}, '',browserUrl);
					}
					if (sortOption) {
						$(document).trigger('sort:trackingSortAnalytics', { sortOption: sortOption });
						$(document).trigger('sort:trackingDynamicImpression');
					}
					$.spinner().stop();
				},
				error: function () {
					$.spinner().stop();
				},
			});
			$this.change();
		});
	});
};

var utils = {
	/**
	 * @desc Media breakpoints that are used throughout the Javascript
	 */
	breakpoints: {
		xs: smallBreakpoint,
		sm: mediumBreakpoint,
		md: largeBreakpoint,
		lg: desktopBreakpoint,
		xl: maxBreakpoint,
		'mobile-menu': desktopBreakpoint,
	},

	/**
	 * @function
	 * @description appends the parameter with the given name and value to the given url and returns the changed url
	 * @param {string} url the url to which the parameter will be added
	 * @param {string} name the name of the parameter
	 * @param {string} value the value of the parameter
	 * @returns {string} - URL with parameter
	 */
	appendParamToURL: function (url, name, value) {
		// quit if the param already exists
		if (url.indexOf(name + '=') !== -1) {
			return url;
		}
		var separator = url.indexOf('?') !== -1 ? '&' : '?';
		return url + separator + name + '=' + encodeURIComponent(value);
	},

	/**
	 * @function
	 * @description remove the parameter and its value from the given url and returns the changed url
	 * @param {string} url the url from which the parameter will be removed
	 * @param {string} name the name of parameter that will be removed from url
	 * @returns {string} - URL without parameter
	 */
	removeParamFromURL: function (url, name) {
		if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
			return url;
		}
		var hash;
		var params;
		var domain = url.split('?')[0];
		var paramUrl = url.split('?')[1];
		var newParams = [];
		// if there is a hash at the end, store the hash
		if (paramUrl.indexOf('#') > -1) {
			hash = paramUrl.split('#')[1] || '';
			paramUrl = paramUrl.split('#')[0];
		}
		params = paramUrl.split('&');
		for (var i = 0; i < params.length; i++) {
			// put back param to newParams array if it is not the one to be removed
			if (params[i].split('=')[0] !== name) {
				newParams.push(params[i]);
			}
		}
		return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
	},

	/**
	 * appends params to a url
	 * @param {string} url - Original url
	 * @param {Object} params - Parameters to append
	 * @returns {string} result url with appended parameters
	 */
	appendToUrl: function (url, params) {
		var newUrl = url;
		newUrl +=
			(newUrl.indexOf('?') !== -1 ? '&' : '?') +
			Object.keys(params)
				.map(function (key) {
					return key + '=' + encodeURIComponent(params[key]);
				})
				.join('&');

		return newUrl;
	},

	/**
	 * appends new params to a url
	 * @param {string} url - Original url
	 * @param {Object} params - New Parameters to select from and append
	 * @returns {string} result url with appended parameters
	 */
	appendParamsToUrl: function (url, params) {
		var newUrl = url;
		newUrl +=
			(newUrl.indexOf('?') !== -1 ? '&' : '?') +
			Object.keys(params)
				.map(function (key) {
					var uri = new URL(url);
					if (uri.searchParams.get(key)) {
						return '';
					} else {
						return key + '=' + encodeURIComponent(params[key]);
					}
				})
				.join('&');

		return newUrl;
	},

	/**
	 * @function
	 * @description extract the query string from URL
	 * @param {string} url the url to extra query string from
	 * @returns {string|Object} - Query String from URL
	 **/
	getQueryString: function (url) {
		var qs;
		if (typeof url !== 'string') {
			return null;
		}
		var a = document.createElement('a');
		a.href = url;
		if (a.search) {
			qs = a.search.substr(1); // remove the leading ?
		}
		return qs;
	},

	/**
	 * @function
	 * @description Converts the given relative URL to an absolute URL
	 * @param {string} url - URL to convert
	 * @returns {string} - Absolute URL
	 */
	toAbsoluteUrl: function (url) {
		var absURL = url;
		if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
			absURL = '/' + url;
		}
		return absURL;
	},

	/**
	 * @function
	 * @description Extracts all parameters from a given query string into an object
	 * @param {string} qs The query string from which the parameters will be extracted
	 * @returns {Object} - Object with params from the query string
	 */
	getQueryStringParams: function (qs) {
		if (!qs || qs.length === 0) {
			return {};
		}
		var params = {};
		var unescapedQS = decodeURIComponent(qs);
		// Use the String::replace method to iterate over each
		// name-value pair in the string.
		unescapedQS.replace(
			new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
			function ($0, $1, $2, $3) {
				params[$1] = $3;
			}
		);
		return params;
	},

	/**
	 * function to get url parameter.
	 * @param {string} parameter key
	 * @param {string} defaultvalue if parameter is missing from url
	 * @returns {string} parameter value or defaultvalue
	 */
	getUrlParam: function (parameter, defaultvalue) {
		var urlparameter = defaultvalue;
		if (window.location.href.indexOf(parameter) > -1) {
			urlparameter = this.getUrlVars()[parameter];
		}
		return urlparameter;
	},

	/**
	 * add parameter to URL
	 * @param {string} paramKey key parameter
	 * @param {string} paramKalue value of parameter
	 */
	insertURLParam: function (paramKey, paramKalue) {
		let key = encodeURIComponent(paramKey);
		let value = encodeURIComponent(paramKalue);

		// kvp looks like ['key1=value1', 'key2=value2', ...]
		var kvp = document.location.search.substr(1).split('&');
		let i = 0;
		for (; i < kvp.length; i++) {
			if (kvp[i].startsWith(key + '=')) {
				let pair = kvp[i].split('=');
				pair[1] = value;
				kvp[i] = pair.join('=');
				break;
			}
		}
		if (i >= kvp.length) {
			kvp[kvp.length] = [key, value].join('=');
		}
		// can return this or...
		let params = kvp.join('&');
		// update current browser state
		let baseUrl = window.location.href.split('?')[0];
		window.history.replaceState({}, document.title, baseUrl + '?' + params);
	},
	/**
	 * Enhancing dropdown
	 */
	enhancingSelectDropdown: function (
		shouldHideSelected,
		selectedQuantity,
		isATCUpdate,
		$activeAccordion
	) {
		if (!isATCUpdate) {
			$('select').each(function () {
				selectDropDownEnhance(
					shouldHideSelected,
					selectedQuantity,
					isATCUpdate,
					$activeAccordion,
					this
				);
			});
			$('body').click(function(e) {
				if(e.target.id === 'customDropdownSelected') {
					return;
				}
				// If backdrop click in case of slick lightbox close lightbox
				if(e.target.classList && e.target.classList.contains('slick-slider') ||
					e.target.classList.contains('slick-lightbox-inner') ||
					e.target.classList.contains('slick-lightbox')){
					$('.slick-lightbox').remove();
					$('body').css('overflow','inherit');
				}else{
					return;
				}
				// $optionsContainer.removeClass('custom-dropdown-active');
			});
		} else {
			selectDropDownEnhance(shouldHideSelected, selectedQuantity, isATCUpdate);
		}
	},
	onLoadSEOUpdateOnViewerImages : function(containerID) {
		var staticImage = $('#'+containerID+'_flyoutZoomView .s7staticimage img');
		var zoomViewImage = $('#'+containerID+'_flyoutZoomView .s7flyoutzoom img');
		var title = $('#'+containerID).data('product-title');
		var alt = $('#'+containerID).data('product-alt');
		staticImage.attr('title',title).attr('alt',alt);
		zoomViewImage.attr('title',title).attr('alt',alt);
	},
	dynamicSEOUpdateOnViewerImages: function (containerID) {
		if ('MutationObserver' in window) {
			const viewerContainer = document.querySelector('#' + containerID);

			// eslint-disable-next-line no-inner-declarations
			function handleNewImage(image) {
				image.alt = $(viewerContainer).data('product-alt');
				image.title = $(viewerContainer).data('product-title');
			}

			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if (mutation.type === 'childList') {
						mutation.addedNodes.forEach((node) => {
							if (node.tagName === 'IMG') {
								handleNewImage(node); // Call the handler for the new image
							}
							// If nodes are added as part of a container (like a div)
							if (node.nodeType === Node.ELEMENT_NODE) {
								const images = node.getElementsByTagName('img');
								for (let img of images) {
									handleNewImage(img); // Handle existing images in the newly added node
								}
							}
						});
					}
				});
			});

			observer.observe(viewerContainer, { childList: true, subtree: true });
		}
	},
	//swipe functionality on viewer
	selectSwatchOnViewerSwipe: function(zm,curEle){
		let touchstartX = 0;
		let touchendX = 0;
		var curEleID = curEle.attr('id');
		var container = $('#'+curEleID+'_container_inner').children().not('[class*=swatches]'); 
		var totalThumbs = (curEle.find('.s7thumbcell')) ? curEle.find('.s7thumbcell').length - 1 : 0; 
		if(totalThumbs > 0 && container){
			

			// eslint-disable-next-line no-inner-declarations
			function checkSwipeDirection() {
				var swatches = zm.getComponent('swatches');
				var curSwatch = curEle.find('.s7thumbcell[aria-selected=true]');
				var curSwatchIndx = parseInt(curEle.find('.s7thumbcell[aria-selected=true]').attr('swindex'));
				if (touchendX < touchstartX){ // Left Swipe
					if(curSwatchIndx <= totalThumbs){
						$(document).trigger('s7image:swipe','Left');
						swatches.selectSwatch(parseInt(curSwatch.next().attr('swindex')),true);
					}
				} 
				if (touchendX > touchstartX){ //right
					if(curSwatchIndx >= 0){
						$(document).trigger('s7image:swipe','Right');
						swatches.selectSwatch(parseInt(curSwatch.prev().attr('swindex')),true);
					}
				}
			}

			
			Array.from(container).forEach(evt => {
				evt.addEventListener('touchstart', e => {
					touchstartX = e.changedTouches[0].screenX;
				});
				evt.addEventListener('touchend', e => {
					touchendX = e.changedTouches[0].screenX;
					checkSwipeDirection();
				});
			});
		} 
	},
};

module.exports = utils;
